import {applyMiddleware, createStore} from 'redux';
import {appReducer} from './reducers';
import thunk from "redux-thunk";
import blockUiMiddleware from "./enhancers/blockUiMiddleware";

const store = createStore(
    appReducer,
    applyMiddleware(thunk, blockUiMiddleware)
);

export default store;
